import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/permissions`)
  return data.data
}

export const usePermissions = () => {
  const { data, ...props } = useQuery(
    queryKeys.PERMISSIONS,
    () => getData(),
  )
  return { data, ...props }
}
